import type { Permissions } from '@mntn-dev/auth-types'

import type { FileArea } from '@mntn-dev/domain-types'
import type { PermissionContext } from './types.ts'

export const createPermissions = ({
  userType,
}: PermissionContext): Permissions => {
  const isInternalUser = userType === 'internal'
  const isBrandUser = userType === 'brand'
  const isMakerUser = userType === 'maker'
  const isSystemUser = userType === 'system'

  return {
    canAcceptOffer: () => isMakerUser,
    canAdministerProjects: () => isInternalUser || isSystemUser,
    canAdministerUsers: () => isInternalUser || isSystemUser,
    canAdministerPackages: () => isInternalUser || isSystemUser,
    canAdministerWatches: () => isSystemUser || isInternalUser,
    canArchiveProject: () => isBrandUser,
    canCommentOnProject: () => isBrandUser || isMakerUser,
    canCompleteProject: () => isMakerUser || isInternalUser || isSystemUser,
    canCreateProject: () => isBrandUser || isSystemUser,
    canCreateReview: () => isSystemUser,
    canCreateWatch: () => isSystemUser,
    canDeclineOffer: () => isMakerUser,
    canDeleteProject: () => isBrandUser,
    canDeleteWatch: () => isSystemUser,
    canEditMatch: () => isInternalUser,
    canEditProject: () => isBrandUser || isInternalUser || isSystemUser,
    canRemoveMatch: () => isInternalUser,
    canSubmitProject: () => isBrandUser || isSystemUser,
    canSubscribeToInternalUpdates: () => isInternalUser || isSystemUser,
    canUpdateWatch: () => isSystemUser,
    //TODO: actually check if the user can upload the file
    canUploadFile: (_fileType: FileArea) =>
      isBrandUser || isMakerUser || isInternalUser || isSystemUser,
    canViewActivity: () =>
      isBrandUser || isMakerUser || isInternalUser || isSystemUser,
    canViewAllActivity: () => isSystemUser,
    canViewAllWatches: () => isSystemUser,
    canViewPackages: () => isBrandUser || isInternalUser || isSystemUser,
    canViewAgency: () => isMakerUser || isInternalUser || isSystemUser,
    canViewBrand: () => isBrandUser || isInternalUser || isSystemUser,
    canViewInternalPricingNote: () =>
      isBrandUser || isInternalUser || isSystemUser,
    canViewOffer: () => isMakerUser || isInternalUser || isSystemUser,
    canViewProject: () =>
      isBrandUser || isMakerUser || isInternalUser || isSystemUser,
    canViewMatch: () => isInternalUser,
    canViewWatch: () => isSystemUser,
    canViewCost: () => isMakerUser || isInternalUser || isSystemUser,
    canViewCostPlusMargin: () => isBrandUser || isInternalUser || isSystemUser,
  }
}
